var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7387 3.09648C24.5992 2.57706 24.3258 2.10337 23.9457 1.72283C23.5656 1.34229 23.0923 1.06825 22.573 0.928125C20.6617 0.414063 13 0.414062 13 0.414062C13 0.414062 5.33828 0.414062 3.42695 0.925391C2.90748 1.06506 2.4339 1.33895 2.05377 1.71956C1.67364 2.10017 1.40034 2.5741 1.26133 3.09375C0.75 5.00781 0.75 9 0.75 9C0.75 9 0.75 12.9922 1.26133 14.9035C1.54297 15.959 2.37422 16.7902 3.42695 17.0719C5.33828 17.5859 13 17.5859 13 17.5859C13 17.5859 20.6617 17.5859 22.573 17.0719C23.6285 16.7902 24.457 15.959 24.7387 14.9035C25.25 12.9922 25.25 9 25.25 9C25.25 9 25.25 5.00781 24.7387 3.09648ZM10.5664 12.6641V5.33594L16.9102 8.97266L10.5664 12.6641Z",
    fill: "#AFD34F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.22117bd99c6f94641dc661918032021d.svg";
export { ForwardRef as ReactComponent };